import React, { useEffect } from "react";
import { AppModel, EmbeddedMode } from "../models";
import { DispatchContext } from "../store";
import { ReflexContainer, ReflexElement } from "react-reflex";
import { getEmbeddedContent } from "./Main";
import { IToolbarElement, Toolbar } from "dhx-suite";
import "react-reflex/styles.css";
import { StaticToolbar } from "./basic/Toolbar";
import { JsSettingsWindow } from "./JsSettingsWindow";

interface SiteWideViewProps {
  state: AppModel;
  versions: string;
  isJsSaved: boolean;
}
const toolbarControls: IToolbarElement[] = [
  {
    id: "jsCode",
    css: `st-mode-tab__embedded`,
    value: "JavaScript",
  },
  {
    id: "htmlCode",
    css: `st-mode-tab__embedded`,
    value: "HTML",
  },
  {
    id: "result",
    css: `st-mode-tab__embedded`,
    value: "Preview",
  },
  {
    type: "spacer",
  },
  {
    id: "settings",
    icon: "mdi mdi-menu-down",
    tooltip: "Settings",
    type: "button",
    view: "link",
    color: "secondary",
    circle: true,
  },
];

export const SiteWideView = ({
  state,
  versions,
  isJsSaved,
}: SiteWideViewProps) => {
  const { dispatch } = React.useContext(DispatchContext);
  const [toolbar, setToolbar] = React.useState<Toolbar>();
  const [mode, setMode] = React.useState<EmbeddedMode>("result");
  const [loading, setLoading] = React.useState<boolean>(false);
  const posibleMode = ["jsCode", "htmlCode", "result"];

  useEffect(() => {
    toolbar?.data.update("jsCode", {
      css: `st-mode-tab__embedded ${mode === "jsCode" ? "active" : ""}`,
    });
    toolbar?.data.update("htmlCode", {
      css: `st-mode-tab__embedded ${mode === "htmlCode" ? "active" : ""}`,
    });
    toolbar?.data.update("result", {
      css: `st-mode-tab__embedded ${mode === "result" ? "active" : ""}`,
    });
  }, [toolbar, mode]);

  useEffect(() => {
    toolbar?.data.update("settings", { value: versions });
  }, [toolbar, versions]);

  return (
    <ReflexContainer style={{overflowY: "hidden"}}>
      <div>
        <StaticToolbar
          className={`st-toolbar st-toolbar-wide st-code-pane--toolbar st-code-pane--js${
            isJsSaved ? "" : " not-saved"
          }`}
          controls={toolbarControls}
          onClick={(id) => {
            if (posibleMode.find((i) => i === id)) {
              setLoading(true);
              setMode(id as EmbeddedMode);
              setTimeout(() => {
                setLoading(false);
              }, 100);
            }
            if (id === "settings") {
              dispatch({ type: "JsSettingsButtonClick" });
            }
          }}
          onToolbarMounted={setToolbar}
        />
      </div>
     
      <div style={{flexGrow: 1}}>
        {!loading &&
          getEmbeddedContent(
            mode,
            state.snippet,
            state.previewInitialized,
            dispatch,
            state.darkTheme,
            state.scriptErrorLine
          )}
      </div>
      <JsSettingsWindow
            settings={state.snippet.jsSettings}
            onClose={() => dispatch({ type: "JsSettingsWindowCloseClick" })}
            visible={state.jsSettingsFormVisible}
            onChange={settings => dispatch({
                type: "JsSettingsChanged",
                settings
            })}
            isDarkTheme={state.darkTheme}
        />
    </ReflexContainer>
  );
};
